<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="$l('drawer_title_authUser') || '授权用户'"
      visible
      direction="rtl"
      size="1000px"
      @close="close"
    >
      <div class="drawer-main">
        <Main ref="main" :roleID="roleID" @reload="$emit('reload')" />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    roleID: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-drawer__body {
    overflow: auto;
  }
}
.drawer-main {
  padding: 0 30px 32px;
}
.drawer-footer {
  padding: 10px 30px 30px;
  display: flex;
  justify-content: flex-end;
}
</style>
